import { IndexedDBWindow } from '../i-indexed-db/i-indexed-db.component';
import { ActionWindow } from '../i-lm-action/services/i-lm-action.service';
import { JSFunctions } from '../i-lm-common/services/api/js-functions-api.service';
import { ConfirmWindow } from '../i-lm-confirm/i-lm-confirm.component';
import { ContextWindow } from '../i-lm-context-menu/i-lm-context-menu-component/i-lm-context-menu.component';
import { NotificationWindow } from '../i-lm-notification/i-lm-notification.component';
import { ModalWindow } from '../i-lm-overlay/i-lm-overlay.component';
import { SpinnerWindow } from '../i-lm-progress/i-lm-progress.component';
import { StateStorage } from '../i-state-storage/i-state-storage.component';

declare global {
  export interface Window 
    extends ActionWindow, 
    SpinnerWindow, 
    ConfirmWindow, 
    NotificationWindow, 
    ModalWindow,
    ContextWindow,
    IndexedDBWindow,
    StateStorage,
    JSFunctions {}
                
  export interface String 
    extends AddStringFunctions {}

  export interface IIDBConfiguration {
    requestUrl: string;
    read: 'alwaysAPI' | 'apiIfNoIDB' | 'alwaysIDB',
    write: 'never' | 'onIDBNotExist' | 'eachUpdate',
    entityId: string,
    expireTimeout?: number
  }
}

interface AddStringFunctions {
  replaceAll: (search: string, replacement: string) => string;
}

String.prototype.replaceAll = function (search, replacement) {
    let target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};